import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAdmin } from "@/lib/auth";
import Analytics from "@/components/Analytics";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import Therapist from "@/pages/Therapist";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Enroll from "@/pages/Enroll";
import Insurance from "@/pages/Insurance";
import LocationPage from "@/pages/LocationPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSubscribers from "@/pages/AdminSubscribers";
import AiStudio from "@/pages/AiStudio";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" />
        <Analytics />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/therapists/waleska-castillo" element={<Therapist />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/new-patient" element={<Enroll />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/areas/:slug" element={<LocationPage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="/admin/ai" element={<RequireAdmin><AiStudio /></RequireAdmin>} />
          <Route path="/admin/subscribers" element={<RequireAdmin><AdminSubscribers /></RequireAdmin>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
